import { create } from "zustand";
import { isExpired } from "@/lib/auth";
function getStoredToken() {
    const token = localStorage.getItem("biotact_access_token");
    if (!token || isExpired(token)) {
        localStorage.removeItem("biotact_access_token");
        return null;
    }
    return token;
}
function getStoredUser() {
    const raw = localStorage.getItem("biotact_user");
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch {
        return null;
    }
}
export const useAuthStore = create((set) => ({
    token: getStoredToken(),
    user: getStoredUser(),
    isAuthenticated: getStoredToken() !== null,
    setAuth: (token, user) => {
        localStorage.setItem("biotact_access_token", token);
        localStorage.setItem("biotact_user", JSON.stringify(user));
        set({ token, user, isAuthenticated: true });
    },
    logout: () => {
        localStorage.removeItem("biotact_access_token");
        localStorage.removeItem("biotact_user");
        set({ token: null, user: null, isAuthenticated: false });
    },
}));
